import { render, staticRenderFns } from "./CallReadModal.vue?vue&type=template&id=48dc3992&scoped=true"
import script from "./CallReadModal.vue?vue&type=script&lang=js"
export * from "./CallReadModal.vue?vue&type=script&lang=js"
import style0 from "./CallReadModal.vue?vue&type=style&index=0&id=48dc3992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc3992",
  null
  
)

export default component.exports